import { useState, useEffect } from 'react';
import { historyService } from '../services/historyService';
import { ONBOARDING_COMPLETED_KEY } from '../components/onboarding/types';

export const useOnboarding = () => {
  const [shouldShow, setShouldShow] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkOnboardingStatus();
  }, []);

  const checkOnboardingStatus = async () => {
    // Check localStorage flag first
    const completed = localStorage.getItem(ONBOARDING_COMPLETED_KEY);
    console.log('Onboarding check - localStorage flag:', completed);

    if (completed === 'true') {
      console.log('Onboarding already completed, hiding popup');
      setShouldShow(false);
      setIsLoading(false);
      return;
    }

    // Check chat history
    try {
      const conversations = await historyService.loadConversationHistory();
      const hasChatHistory = conversations.length > 0;
      console.log('Onboarding check - chat history count:', conversations.length);
      console.log('Onboarding check - shouldShow:', !hasChatHistory);

      // Show only if BOTH conditions are true:
      // 1. No completion flag
      // 2. No chat history
      setShouldShow(!hasChatHistory);
    } catch (error) {
      console.error('Error checking chat history:', error);
      // On error, assume new user (safe to show onboarding)
      console.log('Onboarding check - error, showing popup as fallback');
      setShouldShow(true);
    } finally {
      setIsLoading(false);
    }
  };

  const completeOnboarding = () => {
    localStorage.setItem(ONBOARDING_COMPLETED_KEY, 'true');
    setShouldShow(false);
  };

  const resetOnboarding = () => {
    // For testing purposes
    localStorage.removeItem(ONBOARDING_COMPLETED_KEY);
    setShouldShow(true);
  };

  return { shouldShow, isLoading, completeOnboarding, resetOnboarding };
};
